import { openNetworkErrorDialog } from '@/shared/components/NetworkErrorDialog';
import { toast } from 'sonner';

/**
 * 토스트 — Figma 라이브러리 Toast (840:4478)
 * success: 초록(check-circle) · error: 빨강(warning-circle) · info: 검정(info-circle)
 * 모양 · 아이콘은 App.tsx Toaster의 toastOptions · icons에서 정한다. 위치는 GNB 아래 24px 가운데.
 * 모듈 싱글톤 — 훅 의존성에 넣어도 재생성되지 않게 한다 (admin과 같은 형태)
 */
export const toastApi = {
  success: (content: string, duration = 3) =>
    toast.success(content, { duration: duration * 1000 }),
  error: (content: string, duration = 5) =>
    toast.error(content, { duration: duration * 1000 }),
  info: (content: string, duration = 3) =>
    toast.info(content, { duration: duration * 1000 }),
};

/**
 * X8 — 네트워크 오류 공통 알림. 이제 토스트가 아니라 [확인] 팝업이다 (NetworkErrorDialog).
 * 기존 호출부 이름을 그대로 쓸 수 있게 남겨 둔다.
 */
export const showNetworkErrorToast = () => openNetworkErrorDialog();
